import { IconButton } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

type AnalyticsQuickViewFavoriteToggleProps = {
  favorited: boolean;
  onClick: () => void;
};

export const AnalyticsQuickViewFavoriteToggle = ({
  favorited,
  onClick,
}: AnalyticsQuickViewFavoriteToggleProps): JSX.Element => {
  return (
    <IconButton
      variant="tertiary"
      icon={favorited ? 'star-full' : 'star'}
      iconProps={{
        color: favorited ? colors.orange[300] : colors.neutral[400],
      }}
      onClick={onClick}
    />
  );
};
